import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <TopicsSection />
        <UpdatesSection />
        <CarouselSection />
        <RankingSection />
        <AppSection />
        <CommentsSection />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}